import type { IApiPerson, IPerson } from 'src/interfaces';

export const mapApiToPerson = ({ fullname, ...rest }: IApiPerson): IPerson => {
  return {
    ...rest,
    fullName: fullname,
  };
};
